import React from 'react';
import { BiArrowBack } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom';



const ContentHeader = ({ title, path }: { title: string, path?: string }) => {
  const navigate = useNavigate();

  const navigateHandler = (route: string) => {
    navigate(route);
  }

  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6 d-flex align-items-center">
            {path && <span className="mx-4"><BiArrowBack onClick={() => navigateHandler(path)} style={{ fontSize: '30px', cursor: 'pointer' }} title="Back" /></span>}
            <h1>{title}</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>

              <li className="breadcrumb-item active">{title}</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentHeader;
